import * as NumberUtils from '@/utils/NumberUtils'
import * as EQSize from '../parameters/EQSize'
import { cache } from '@/utils/cacheManager'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CargoDocUtil } from './CargoDocUtil'
import StrUtils from '@/utils/StrUtils'
import { UnitLoadDevice } from '@/class/model/booking/UnitLoadDevice'
import { UnitLoadDeviceUsage } from '@/class/model/booking/UnitLoadDeviceUsage'
import uidUtil from '@/utils/uidUtil'
import i18n from '@/lang'
import { getUuid } from '@/utils'
import lang from '@/lang'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'

export class UnitLoadDeviceUtil {
  /**
   * 主票自动装箱
   */
  static autoAdjustMasterContainer(job) {
    // 获取新增的container,条件是：没有修改过的SeaEQ和不存在container里面
    const airUlds = this.getCreateContainerBySeaEQ(job)
    this.createMasterContainer(airUlds, job)
    // 同步变更的箱种箱型，条件是：装箱信息和箱种箱型数量一致
    this.syncContainerSeaEQ(job)
    // 删除多余的装箱信息
    this.removeMasterContainer(job)
  }

  /**
     * 创建主票装箱信息
     */
  static createMasterContainer(airUlds, job) {
    for (const item of airUlds) {
      const quantity = item['quantity']
      const airUld = item['airUld']
      for (let i = 0; i < quantity; i++) {
        const uld = new UnitLoadDevice().fillDefaultValue().getData()

        uld.isDirty = true
        uld.jobUuid = job.uuid
        if (!job.unitLoadDevices) {
          job.unitLoadDevices = []
        }
        job.unitLoadDevices.push(uld)

        uld.containerType = airUld.containerType
        uld.containerCode = airUld.containerCode
        uld.containerNumber = ''
        uld.board = airUld.board
        uld.airUlds = airUld
      }
    }
  }

  /**
     * 刷新装箱信息箱型箱量
     */
  static syncContainerSeaEQ(job) {
    for (const uld of job.airUld) {
      for (const container of job.unitLoadDevices) {
        if (container.airUlds && container.airUlds.joinContainerId === uld.joinContainerId && (container.containerCode !== uld.containerCode || container.containerType !== uld.containerType)) {
          container.containerCode = uld.containerCode
          container.containerType = uld.containerType
          container.isDirty = true
        }
      }
    }
  }

  /**
     * 删除多余的装箱信息
     */
  static removeMasterContainer(job) {
    const unitLoadDevices = []
    for (const c of job.unitLoadDevices) {
      c.delete = false
      if (!this.isMatchSeqInfo(c, job) && StrUtils.isEmpty(c.containerNumber)) {
        unitLoadDevices.push(c)
      }
    }
    for (const s of job.airUld) {
      const diffs = this.getDiffSeqEqContainer(s, job)
      const needDeleCount = diffs.length - s.quantity
      if (needDeleCount > 0) {
        const allowDelete = this.getAllowDeleteContainerByMaster(diffs)
        if (allowDelete.length > 0) {
          for (let i = 0; i < needDeleCount; i++) {
            if (i <= allowDelete.length) {
              unitLoadDevices.push(allowDelete[i])
            }
          }
        }
      }
    }
    if (unitLoadDevices.length > 0) {
      for (const c3 of unitLoadDevices) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(c3.uuid)) {
          if (!job.delUnitLoadDeviceUuids) {
            job.delUnitLoadDeviceUuids = []
          }
          job.delUnitLoadDeviceUuids.push(c3.uuid)
        }
        c3.jobUuid = ''
        c3.delete = true
      }
    }
    // job.unitLoadDevices.refresh(); 刷新 job 下的containers
    // 根据  jobUuid ，unitLoadDeviceUuid 清除 对象上的 [] ,新增状态jobUuid =null
    const tempContainers = []
    for (const container of job.unitLoadDevices) {
      if (!container.delete) {
        tempContainers.push(container)
      }
    }

    job.unitLoadDevices.splice(0, job.unitLoadDevices.length, ...tempContainers)
  }

  /**
     * 删除没有装过小票的箱子
     */
  static getAllowDeleteContainerByMaster(unitLoadDevices) {
    const result = []
    for (const c of unitLoadDevices) {
      if ((!c.unitLoadDeviceUsage || c.unitLoadDeviceUsage.length === 0) && StrUtils.isEmpty(c.containerNumber)) {
        result.push(c)
      }
    }
    return result
  }

  /**
   *  获取新增的container
   *  1.没有修改过箱种箱型
   *  2.完全新增了一个箱种箱型
   */
  static getCreateContainerBySeaEQ(job) {
    const airUlds = []
    for (const sea of job.airUld) {
      const checkCount = this.getJoinContainerCount(sea, job)
      const diff = sea.quantity - checkCount
      // checkCount == 0 说明是新增的箱型信息
      if (checkCount === 0) {
        airUlds.push({ 'quantity': sea.quantity, 'airUld': sea })
      } else {
        if (diff > 0) {
          airUlds.push({ 'quantity': diff, 'airUld': sea })
        }
      }
    }
    return airUlds
  }

  static getJoinContainerCount(sea, job) {
    let count = 0
    for (const container of job.unitLoadDevices) {
      if (container.airUlds && container.airUlds.joinContainerId === sea.joinContainerId) {
        count++
      }
    }
    return count
  }

  /**
   *获取 箱量描述
   */
  static getSeaeqNumberStr(obj) {
    let amount = 0
    if (obj.airUld instanceof Array) {
      for (const s of obj.airUld) {
        amount += s.quantity
      }
    }
    return StrUtils.jsdx(amount, 'CONTAINER(S)')
  }

  /**
   *比较订舱单和装箱的件重体 obj
   *返回null：表示全部相符
   */
  static getCompareMessage(obj, quantity, weight, cubage) {
    let strQuantity = 0
    let strWeight = 0
    let strCubage = 0
    let strAlert = ''
    let msg = ''

    if (quantity === 0 && weight === 0 && cubage === 0) { return null }
    // CARGO-8232, 装箱信息件毛体和实际件毛体信息一致，无法保存
    strQuantity = isNaN(obj.quantityActual) ? 0 : Number(obj.quantityActual)
    strWeight = isNaN(obj.weightActual) ? 0 : Number(obj.weightActual)
    strCubage = isNaN(obj.cubageActual) ? 0 : Number(obj.cubageActual)

    strAlert = lang.t('SeaExport.Actual')
    // fix bug 1691 by marco.
    if (strQuantity === 0 && strWeight === 0 && strCubage === 0) {
      strQuantity = isNaN(obj.quantityContract) ? 0 : Number(obj.quantityContract)
      strWeight = isNaN(obj.weightContract) ? 0 : Number(obj.weightContract)
      strCubage = isNaN(obj.cubageContract) ? 0 : Number(obj.cubageContract)
      strAlert = lang.t('SeaExport.Consignation')
    }

    if (quantity === strQuantity && weight === strWeight && cubage === strCubage) { return null }

    if (!StrUtils.NumberIsSame(quantity, strQuantity)) {
      if (quantity > strQuantity) {
        msg += lang.t('SeaExport.TotalNumberOfPackages') + quantity + ' ' + lang.t('CargoMsg.Cargo_GreaterThan') + strAlert + lang.t('SeaExport.Quantity') + strQuantity + '\n'
      } else {
        msg += lang.t('SeaExport.TotalNumberOfPackages') + quantity + ' ' + lang.t('CargoMsg.Cargo_LessThan') + strAlert + lang.t('SeaExport.Quantity') + strQuantity + '\n'
      }
    }

    if (!StrUtils.NumberIsSame(weight, strWeight, 2)) {
      if (weight > strWeight) {
        msg += lang.t('SeaExport.TotalWeight2') + weight + ' ' + lang.t('CargoMsg.Cargo_GreaterThan') + strAlert + lang.t('SeaExport.Weight2') + strWeight + '\n'
      } else {
        msg += lang.t('SeaExport.TotalWeight2') + weight + ' ' + lang.t('CargoMsg.Cargo_LessThan') + strAlert + lang.t('SeaExport.Weight2') + strWeight + '\n'
      }
    }
    if (!StrUtils.NumberIsSame(cubage, strCubage, 3)) {
      if (cubage > strCubage) {
        msg += lang.t('SeaExport.TotalCubage') + cubage + ' ' + lang.t('CargoMsg.Cargo_GreaterThan') + strAlert + lang.t('SeaExport.Cubage') + strCubage + '\n'
      } else {
        msg += lang.t('SeaExport.TotalCubage') + cubage + ' ' + lang.t('CargoMsg.Cargo_LessThan') + strAlert + lang.t('SeaExport.Cubage') + strCubage + '\n'
      }
    }
    if (msg === '') {
      return null
    }
    return msg
  }

  /**
   * true: 有重复
   * false:无重复
   */
  static checkNoDuplationSeaEQ(job) {
    if (job.lclMasterUuid) {
      return false
    }
    if (!job.airUld || job.airUld.length === 0) {
      return false
    }
    for (const s of job.airUld) {
      if (this.checkSeaEq(job, s)) {
        return true
      }
    }
    return false
  }

  /**
   * 校验是否有空值
   * @param job
   * @returns {string|*}
   */
  static checkInput(job) {
    if (!job.airUld || job.airUld.length === 0) {
      return ''
    }
    for (const s of job.airUld) {
      if (!s.containerType) {
        // 集装器类型不能为空
        return lang.t('CargoMsg.Cargo_ApplicableContainerType') + lang.t('CargoMsg.Cargo_CanNotEmpty')
      }
      if (!s.containerCode) {
        // 集装器代码不能为空
        return lang.t('CargoMsg.Cargo_ApplicableContainerCode') + lang.t('CargoMsg.Cargo_CanNotEmpty')
      }
    }
    return ''
  }

  /** 箱型箱种输入验证
     * 不正确 return true;
     */
  static checkSeaEq(job, seaEq) {
    for (const s of job.airUld) {
      if (seaEq !== s && s.containerType === seaEq.containerType && s.containerCode === seaEq.containerCode) {
        return true
      }
    }
    return false
  }

  /**
   * 验证箱量是否有值
   * true: 有重复
   * false:无重复
   */
  static checkQuantityFromSeaEQ(job) {
    for (const s of job.airUld) {
      if (s.deleted) continue
      if (!s.quantity || Number(s.quantity) <= 0) {
        return true
      }
    }
    return false
  }

  /**
   * 自动装箱
   */
  static autoLoadContainerUsage(job) {
    const quantity = job.quantityActual
    const weight = isNaN(job.weightActual) ? 0 : job.weightActual
    const cubage = isNaN(job.cubageActual) ? 0 : job.cubageActual
    if (quantity === 0 && weight === 0 && cubage === 0 || job.unitLoadDeviceUsages === null) { return }

    let usage

    const len = job.unitLoadDeviceUsages.length
    if (len === 0) { return }
    if (len === 1) {
      usage = job.unitLoadDeviceUsages[0]
      usage.quantity = quantity
      usage.weight = weight
      usage.cubage = cubage
      this.setUnitLoadDeviceData(usage, job)
      return
    }
    let tq = quantity
    let tw = weight
    let tc = cubage
    for (let i = 0; i < len; i++) {
      usage = job.unitLoadDeviceUsages[i]
      if (i === len - 1) {
        usage.quantity = NumberUtils.roundHalfUp(tq, 0)
        usage.weight = NumberUtils.roundHalfUp(tw, 3)
        usage.cubage = NumberUtils.roundHalfUp(tc, 3)
      } else {
        // 计算件数
        const strQuantity = usage.cargoWeight > weight ? quantity : quantity * (usage.cargoWeight / weight)
        tq -= usage.quantity = NumberUtils.roundHalfUp(strQuantity > tq ? tq : strQuantity, 0)
        tw -= usage.weight = NumberUtils.roundHalfUp(usage.cargoWeight > tw ? tw : usage.cargoWeight, 3)
        tc -= usage.cubage = NumberUtils.roundHalfUp(usage.cargoCapacity > tc ? tc : usage.cargoCapacity, 3)
      }
      this.setUnitLoadDeviceData(usage, job)
    }
  }

  static setUnitLoadDeviceData(usage, job) {
    if (usage.unitLoadDevice) {
      usage.unitLoadDevice.cargoName = usage.cargoName = job.cargoEnglishName
      usage.unitLoadDevice.quantity = usage.quantity
      usage.unitLoadDevice.weight = usage.weight
      usage.unitLoadDevice.cubage = usage.cubage
    }
    usage.hsCode = job.hsCode
  }

  /**
   * 自动装箱(委托)
   */
  static autoLoadContainerUsageContract(job) {
    let quantity = job.quantityContract
    let weight = isNaN(job.weightContract) ? 0 : job.weightContract
    let cubage = isNaN(job.cubageContract) ? 0 : job.cubageContract

    if (quantity === 0 && weight === 0 && cubage === 0) {
      quantity = job.quantityActual
      weight = isNaN(job.weightActual) ? 0 : job.weightActual
      cubage = isNaN(job.cubageActual) ? 0 : job.cubageActual
    }

    if (quantity === 0 && weight === 0 && cubage === 0 || job.unitLoadDeviceUsages === null) { return }

    let usage
    let tsize = 0
    for (usage of job.unitLoadDeviceUsages) {
      const eqsize = EQSize.getEQSizeByCode(usage.unitLoadDevice.eqSize)
      if (eqsize) { tsize += parseInt(eqsize.code) }
    }

    let tq = 0
    let tw = 0
    let tc = 0
    const len = job.unitLoadDeviceUsages.length
    for (let i = 0; i < len; i++) {
      usage = job.unitLoadDeviceUsages[i]
      // CARGO-8266，铁路出口业务，自动装箱不要分摊
      if (job.lob === 'RE' || job.lob === 'RI') {
        if (i === 0) {
          usage.quantityContract = quantity
          usage.weightContract = weight
          usage.cubageContract = cubage
        }
      } else {
        if (i === len - 1) {
          usage.quantityContract = NumberUtils.roundHalfUp(quantity - tq, 0)
          usage.weightContract = NumberUtils.roundHalfUp(weight - tw, 3)
          usage.cubageContract = NumberUtils.roundHalfUp(cubage - tc, 3)
        } else {
          const size = EQSize.getEQSizeByCode(usage.unitLoadDevice.eqSize)
          if (size) {
            const rate = parseInt(size.code) / tsize
            tq += usage.quantityContract = NumberUtils.roundHalfUp(rate * quantity, 0)
            tw += usage.weightContract = NumberUtils.roundHalfUp(rate * weight, 3)
            tc += usage.cubageContract = NumberUtils.roundHalfUp(rate * cubage, 3)
          } else {
            usage.quantityContract = usage.weightContract = usage.cubageContract = 0
          }
        }
      }
    }
  }

  /**
     * 验证件毛体是否相同(一个job装到一个箱子中时直接更新件毛体)
     */
  static validateContainerUsage(job) {
    let quantity = 0
    let weight = 0
    let cubage = 0
    for (const usage of job.unitLoadDeviceUsages) {
      quantity += isNaN(usage.quantity) ? 0 : Number(usage.quantity)
      weight += isNaN(usage.weight) ? 0 : Number(usage.weight)
      cubage += isNaN(usage.cubage) ? 0 : Number(usage.cubage)
    }
    quantity = Number(quantity.toFixed())
    weight = Number(weight.toFixed(3))
    cubage = Number(cubage.toFixed(3))
    return this.getCompareMessage(job, quantity, weight, cubage)
  }

  // 刷新装箱明细实际件毛体
  static refreshContainerUsageActualQwc(job) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (expression === 0) return
    if (!job) return
    if (this.checkDocBillType(job)) return
    if (job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length === 1) {
      const usage = job.unitLoadDeviceUsages[0]
      if (expression === 2 || expression === 3) {
        if (job.quantityActual > 0) {
          usage.quantity = job.quantityActual
        }
        if (job.weightActual > 0) {
          usage.weight = job.weightActual
        }
        if (job.cubageActual > 0) {
          usage.cubage = job.cubageActual
        }
      }
    }
  }

  // 刷新装箱明细委托件毛体
  static refreshContainerUsageContractQwc(job, contractField) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (expression === 0) return
    if (!job) return
    if (contractField !== 'quantityContract' && contractField !== 'weightContract' && contractField !== 'cubageContract') return
    if (this.checkDocBillType(job)) return
    if (job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length === 1) {
      const usage = job.unitLoadDeviceUsages[0]
      if (expression === 2 || expression === 3) {
        if (job[contractField] > 0) {
          usage[contractField] = job[contractField]
        }
      }
    }
  }

  /**
     * CARGO-1492
     * 已经拼箱的业务支持货物数量直接更改
     * 1.更改后自动更新装箱的数据
     * 2.如果有拆并单、一个委托在多个箱子中，则提示用户移出装箱后更改
     * 参数：ContainerUpdateJobQCW
     * 1、0:无同步;1:装箱->实际;2:实际->装箱;3:实际与装箱一致
     * 2、493需要配置为2
     * 3、475需要配置为1
     **/
  static async refContainerUsageQwc(job, viewPager = 0, btnSave = true) {
    const expression = parseInt(cache.config.get('ContainerUpdateJobQCW'))
    if (expression === 0) return
    if (!job) return
    if (this.checkDocBillType(job)) return
    if (job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length === 1) {
      const usage = job.unitLoadDeviceUsages[0]
      switch (expression) {
        case 1:
        {
          if (viewPager !== 2) {
            await this.containerQwcSynJob(job, usage)
          }
          break
        }
        case 2:
        {
          if (viewPager !== 1) {
            this.containerJobSynQwc(job, usage)
          }
          break
        }
        case 3:
        {
          if (viewPager === 0 || viewPager === 2) {
            this.containerJobSynQwc(job, usage)
          } else {
            await this.containerQwcSynJob(job, usage)
          }
          break
        }
        default:
        {
          break
        }
      }
    } else if (btnSave && job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length > 1) { // CARGO-7908 装箱信息页，多个箱子的话能将所有箱子的件毛体之和同步过基本面的实际件毛体（单向同步：装箱->实际）
      const usageArray = job.unitLoadDeviceUsages
      switch (expression) {
        case 1:
        {
          if (viewPager !== 2) {
            this.containerQwcArraySynJob(job, usageArray)
          }
          break
        }
        case 3:
        {
          if (viewPager !== 0 && viewPager !== 2) {
            this.containerQwcArraySynJob(job, usageArray)
          }
          break
        }
        default:
        {
          break
        }
      }
    }
  }

  /**
     * 装箱同步Job
     */
  static async containerQwcSynJob(job, usage) {
    if (usage.quantity > 0) {
      job.quantityActual = isNaN(usage.quantity) ? 0 : usage.quantity
    }
    if (usage.weight > 0) {
      job.weightActual = isNaN(usage.weight) ? 0 : usage.weight
    }
    if (usage.cubage > 0) {
      job.cubageActual = isNaN(usage.cubage) ? 0 : usage.cubage
    }
    if (job) {
      await CargoDocUtil.changeSynBillOfLadingQWC(job)
      // 同步委托件毛体
      const rule = parseInt(cache.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        job.quantityContract = job.quantityActual
        job.weightContract = job.weightActual
        job.cubageContract = job.cubageActual
      }
      this.calculateChargeWeightSyn(job)
    }
  }

  /**
     * Job同步装箱
     */
  static containerJobSynQwc(job, usage) {
    if (job.quantityActual > 0) {
      usage.quantity = job.quantityActual
    }
    if (job.weightActual > 0) {
      usage.weight = job.weightActual
    }
    if (job.cubageActual > 0) {
      usage.cubage = job.cubageActual
    }

    // 同时更新箱子上的件毛体
    if (Object.prototype.hasOwnProperty.call(usage, 'container') && usage.unitLoadDevice) {
      usage.unitLoadDevice.quantity = usage.quantity
      usage.unitLoadDevice.weight = usage.weight
      usage.unitLoadDevice.cubage = usage.cubage
    }
  }

  /**
     * CARGO-7908 多个装箱同步Job
     */
  static containerQwcArraySynJob(job, usageArray) {
    var quantity = 0
    var weight = 0
    var cubage = 0

    for (const usage of usageArray) {
      if (!isNaN(usage.quantity)) { quantity += Number(usage.quantity) }
      if (!isNaN(usage.weight)) { weight += Number(usage.weight) }
      if (!isNaN(usage.cubage)) { cubage += Number(usage.cubage) }
    }

    if (quantity > 0) {
      job.quantityActual = quantity
    }
    if (weight > 0) {
      job.weightActual = weight
    }
    if (cubage > 0) {
      job.cubageActual = cubage
    }
    if (job != null) {
      CargoDocUtil.changeSynBillOfLadingQWC(job)
      // 同步委托件毛体
      const rule = parseInt(cache.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        job.quantityContract = job.quantityActual
        job.weightContract = job.weightActual
        job.cubageContract = job.cubageActual
      }
      this.calculateChargeWeightSyn(job)
    }
  }

  /**
     * 计费重量修改计算
     */
  static calculateChargeWeightSyn(job) {
    try {
      var ChargeWeightValueType = ChargeUtils.getChargeWeightValueType(true)
      var weight = ChargeWeightValueType === 1 ? job.weightContract : job.weightActual
      var cubage = ChargeWeightValueType === 1 ? job.cubageContract : job.cubageActual
      if (isNaN(weight) || isNaN(cubage)) return
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      job.chargeWeight = parseFloat(Number(weight).toFixed(3))

      const defaultCubage = parseInt(cache.config.get('ExportChargeCubageMT'))
      if (job.cubageActual <= defaultCubage) {
        job.chargeCubage = defaultCubage
      } else {
        job.chargeCubage = job.cubageActual
      }
      // eslint-disable-next-line no-empty
    } catch (e) {

    }
  }

  /**
     * 是否做过拆并单
     */
  static checkDocBillType(job) {
    for (const doc of job.cargoDoc) {
      if (doc.docType === CargoDocConsts.HBL2) {
        if (job.typeHBL === BillType.MERGE_BILL_TYPE.code || job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
          return true
        }
      }
    }
    return false
  }

  /**
   *  h5 新加的方法，组装 unitLoadDevices.unitLoadDeviceUsages  同 job.unitLoadDeviceUsages 指向同一usage
   *  此方法 处理的仅针对db 已存在的数据 进行组装关联
   * @param job
   */
  static buildUnitLoadDeviceUsages(job) {
    for (const container of job.unitLoadDevices) {
      if (StrUtils.isEmpty(container.uuid)) {
        continue
      }
      container.unitLoadDeviceUsages = []
      if (job.unitLoadDeviceUsages) {
        for (const usage of job.unitLoadDeviceUsages) {
          if (usage.unitLoadDeviceUuid === container.uuid) {
            container.unitLoadDeviceUsages.push(usage)
            usage.unitLoadDevice = container
          }
        }
      }
    }
  }
  /**
     * 根据SEQ 刷新装箱信息
     */
  static autoJustUnitLoadDeviceUsages(job, action = '', canRemoved = true) {
    // 新增装箱信息
    if (job.airUld && job.airUld.length > 0) {
      for (let i = job.airUld.length - 1; i >= 0; i--) {
        const sea = job.airUld[i]
        const containerNumber = this.getJobContainerNumber(sea, job)
        if (containerNumber < sea.quantity) {
          const quantity = sea.quantity - containerNumber
          for (let j = 0; j < quantity; j++) {
            this.addJobContainerUsages(sea, job)
          }
        }
      }
    }
    // 避免 copy,split动作 根据jobUuid 清空了数据
    if (canRemoved && (action !== 'split' || action !== 'copy')) {
      this.removeJobContainerUsages(job)
    }
  }

  /**
   * 根据SEQ 刷新装箱信息
   * 与上面刷新autoJustContainerUsages不同，
   * 当箱号 封号已经填写 一样会有删除逻辑
   *
   */
  static autoJustContainerUsages2(job) {
    // 新增装箱信息
    if (job.airUld && job.airUld.length > 0) {
      const seaEqList = []
      this.setSeaEqList(job, seaEqList)
      for (let i = seaEqList.length - 1; i >= 0; i--) {
        const sea = seaEqList[i]
        const containerNumber = this.getJobContainerNumber2(sea, job)
        if (containerNumber < sea.quantity) {
          const quantity = sea.quantity - containerNumber
          for (let j = 0; j < quantity; j++) {
            this.addJobContainerUsages2(sea, job)
          }
        }
      }

      this.removeJobContainerUsages2(job)
    }
  }
  /**
   * 存在多个eqSize，eqType相同的情况
   * 先汇总在计算箱子
   * @param job
   * @param seaEqList
   */
  static setSeaEqList(job, seaEqList) {
    // 记录箱子原数量
    for (const data of job.airUld) {
      data.dataQuantity = data.quantity
    }
    for (const data of job.airUld) {
      const key = data.eqType + data.eqSize + data.containerNumber + data.sealNo + data.dataQuantity
      let isE = false
      for (const newData of seaEqList) {
        const newKey = newData.eqType + newData.eqSize + newData.containerNumber + newData.sealNo + newData.dataQuantity
        if (key === newKey) {
          newData.quantity += data.quantity
          isE = true
        }
      }
      if (!isE) {
        seaEqList.push({ ...data })
      }
    }
  }
  static getJobContainerNumber2(sea, job) {
    let num = 0
    const unitLoadDevices = job.unitLoadDevices
    if (unitLoadDevices != null && unitLoadDevices.length > 0) {
      for (let i = unitLoadDevices.length - 1; i >= 0; i--) {
        const c = unitLoadDevices[i]
        if (this.check2(c, sea)) {
          num += 1
        }
      }
    }
    return num
  }

  static check2(c, s) {
    if (c.eqType === s.eqType && c.eqSize === s.eqSize && c.containerNumber === s.containerNumber &&
        c.sealNo === s.sealNo) {
      return true
    }
    return false
  }

  static addJobContainerUsages2(sea, job) {
    const container = new UnitLoadDevice().fillDefaultValue().getData()
    const u = new UnitLoadDeviceUsage().fillDefaultValue().getData()

    container.isDirty = true
    u.isDirty = true

    u.unitLoadDevice = container

    u.jobUuid = job.uuid
    if (!job.unitLoadDeviceUsages) {
      job.unitLoadDeviceUsages = []
      job.unitLoadDeviceUsages.push(u)
    } else {
      job.unitLoadDeviceUsages.push(u)
    }

    container.jobUuid = job.uuid
    if (!job.unitLoadDevices) {
      job.unitLoadDevices = []
      job.unitLoadDevices.push(container)
    } else {
      job.unitLoadDevices.push(container)
    }

    // todo 此处会导致json 循环引用 与箱子关联的 装箱信息
    container.unitLoadDeviceUsages = []
    container.unitLoadDeviceUsages.push(u)

    container.containerCode = sea.containerCode
    container.containerNumber = sea.containerNumber
    container.containerType = sea.containerType
    container.board = sea.board
    container.inSpected = false
    u.quantity = 0
    u.weight = 0
    u.cubage = 0

    // 列显示 箱子相关信息 移至 usage
    u.containerCode = container.containerCode
    u.containerNumber = container.containerNumber
    u.containerType = container.containerType
  }

  /**
     * @private
     */
  static addJobContainerUsages(sea, job) {
    const container = new UnitLoadDevice().fillDefaultValue().getData()
    const u = new UnitLoadDeviceUsage().fillDefaultValue().getData()

    container.isDirty = true
    u.isDirty = true

    u.unitLoadDevice = container

    u.jobUuid = job.uuid
    if (!job.unitLoadDeviceUsages) {
      job.unitLoadDeviceUsages = []
      job.unitLoadDeviceUsages.push(u)
    } else {
      job.unitLoadDeviceUsages.push(u)
    }

    container.jobUuid = job.uuid
    if (!job.unitLoadDevices) {
      job.unitLoadDevices = []
      job.unitLoadDevices.push(container)
    } else {
      job.unitLoadDevices.push(container)
    }

    // todo 此处会导致json 循环引用 与箱子关联的 装箱信息
    container.unitLoadDeviceUsage = []
    container.unitLoadDeviceUsage.push(u)

    container.containerNumber = ''
    container.containerType = sea.containerType
    container.containerCode = sea.containerCode
    container.board = sea.board
    container.inSpected = false
    u.quantity = 0
    u.weight = 0
    u.cubage = 0

    // 列显示 箱子相关信息 移至 usage
    u.containerType = container.containerType
    u.containerCode = container.containerCode
    u.containerNumber = container.containerNumber
  }

  /**
     * 删除不匹配的箱子信息
     */
  static removeJobContainerUsages(job) {
    if (job && job.unitLoadDevices) {
      const containerLen = job.unitLoadDevices.length
      // 先根据序号排个序在删除 ，优先新增未存数据，其次序号小的
      if (job.unitLoadDevices) {
        job.unitLoadDevices.sort((a, b) => {
          let num1 = 0
          let num2 = 0
          if (a.unitLoadDeviceUsage && a.unitLoadDeviceUsage.length > 0) {
            num1 = a.unitLoadDeviceUsage[0].serialNo
          }
          if (b.unitLoadDeviceUsage && b.unitLoadDeviceUsage.length > 0) {
            num2 = b.unitLoadDeviceUsage[0].serialNo
          }
          return num1 - num2
        })
      }
      for (let i = containerLen - 1; i >= 0; i--) {
        const c = job.unitLoadDevices[i]
        c.delete = false
        if (!this.isMatchSeqInfo(c, job) && StrUtils.isEmpty(c.containerNumber)) {
          for (const cu1 of c.unitLoadDeviceUsage) {
            cu1.unitLoadDeviceUuid = ''
            cu1.jobUuid = ''
          }
          c.jobUuid = ''
          c.delete = true
        }
      }
      const unitLoadDevices = []
      for (const s of job.airUld) {
        const diffs = this.getDiffSeqEqContainer(s, job)
        var needDeleCount = diffs.length - s.quantity
        if (needDeleCount > 0) {
          const allowDelete = this.getAllowDeleteContainer(diffs)
          if (allowDelete.length > 0) {
            for (let count = 0; count < needDeleCount; count++) {
              if (count < allowDelete.length) {
                const c2 = allowDelete[count] // UnitLoadDevice
                if (!this.checkLclSlavesUsage(job, c2)) {
                  if (c2.unitLoadDeviceUsage != null && c2.unitLoadDeviceUsage.length > 0) {
                    for (let j = c2.unitLoadDeviceUsage.length - 1; j >= 0; j--) {
                      const usage = c2.unitLoadDeviceUsage[j]
                      usage.jobUuid = ''
                      usage.unitLoadDeviceUuid = ''
                    }

                    unitLoadDevices.push(c2)
                  }
                }
              }
            }
          }
        }
      }
      if (unitLoadDevices.length > 0) {
        for (let k = unitLoadDevices.length - 1; k >= 0; k--) {
          const c3 = unitLoadDevices[k]
          c3.delete = false
          if (c3.unitLoadDeviceUsage !== null && c3.unitLoadDeviceUsage.length > 0) {
            for (let m = c3.unitLoadDeviceUsage.length - 1; m >= 0; m--) {
              const usage2 = c3.unitLoadDeviceUsage[m]
              usage2.jobUuid = ''
              usage2.unitLoadDeviceUuid = ''
            }
          }
          c3.jobUuid = ''
          c3.delete = true
        }
      }
      // 根据  箱子上的 delete 标识 刷新job.unitLoadDevices
      const tempContainers = []
      for (const container of job.unitLoadDevices) {
        if (!container.delete) {
          tempContainers.push(container)
        }
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (container.delete && !StrUtils.isEmpty(container.uuid)) {
          if (!job.delUnitLoadDeviceUuids) {
            job.delUnitLoadDeviceUuids = []
          }
          job.delUnitLoadDeviceUuids.push(container.uuid)
        }
      }

      job.unitLoadDevices.splice(0, job.unitLoadDevices.length, ...tempContainers)

      // 箱子 下的装箱 usage 集合到job 上
      const unitLoadDeviceUsages = []
      for (const container of job.unitLoadDevices) {
        for (const usage of container.unitLoadDeviceUsage) {
          unitLoadDeviceUsages.push(usage)
        }
      }
      job.unitLoadDeviceUsages.splice(0, job.unitLoadDeviceUsages.length, ...unitLoadDeviceUsages)
    }
  }
  /**
   * 删除不匹配的箱子信息
   */
  static removeJobContainerUsages2(job) {
    if (job && job.unitLoadDevices) {
      const containerLen = job.unitLoadDevices.length
      // 先根据序号排个序在删除 ，优先新增未存数据，其次序号小的
      if (job.unitLoadDevices) {
        job.unitLoadDevices.sort((a, b) => {
          let num1 = 0
          let num2 = 0
          if (a.unitLoadDeviceUsages && a.unitLoadDeviceUsages.length > 0) {
            num1 = a.unitLoadDeviceUsages[0].serialNo
          }
          if (b.unitLoadDeviceUsages && b.unitLoadDeviceUsages.length > 0) {
            num2 = b.unitLoadDeviceUsages[0].serialNo
          }
          return num1 - num2
        })
      }
      const seaEqList = []
      this.setSeaEqList(job, seaEqList)
      for (let i = containerLen - 1; i >= 0; i--) {
        const c = job.unitLoadDevices[i]
        c.delete = false
        if (!this.isMatchSeqInfo2(c, seaEqList)) {
          for (const cu1 of c.unitLoadDeviceUsages) {
            cu1.unitLoadDeviceUuid = ''
            cu1.jobUuid = ''
          }
          c.jobUuid = ''
          c.delete = true
        }
      }
      const unitLoadDevices = []
      for (const s of seaEqList) {
        const diffs = this.getDiffSeqEqContainer2(s, job, true)
        var needDeleCount = diffs.length - s.quantity
        if (needDeleCount > 0) {
          const allowDelete = this.getAllowDeleteContainer(diffs, true)
          if (allowDelete.length > 0) {
            for (let count = 0; count < needDeleCount; count++) {
              if (count < allowDelete.length) {
                const c2 = allowDelete[count] // UnitLoadDevice
                if (!this.checkLclSlavesUsage(job, c2)) {
                  if (c2.unitLoadDeviceUsages != null && c2.unitLoadDeviceUsages.length > 0) {
                    for (let j = c2.unitLoadDeviceUsages.length - 1; j >= 0; j--) {
                      const usage = c2.unitLoadDeviceUsages[j]
                      usage.jobUuid = ''
                      usage.unitLoadDeviceUuid = ''
                    }

                    unitLoadDevices.push(c2)
                  }
                }
              }
            }
          }
        }
      }
      if (unitLoadDevices.length > 0) {
        for (let k = unitLoadDevices.length - 1; k >= 0; k--) {
          const c3 = unitLoadDevices[k]
          c3.delete = false
          if (c3.unitLoadDeviceUsages !== null && c3.unitLoadDeviceUsages.length > 0) {
            for (let m = c3.unitLoadDeviceUsages.length - 1; m >= 0; m--) {
              const usage2 = c3.unitLoadDeviceUsages[m]
              usage2.jobUuid = ''
              usage2.unitLoadDeviceUuid = ''
            }
          }
          c3.jobUuid = ''
          c3.delete = true
        }
      }
      // 根据  箱子上的 delete 标识 刷新job.unitLoadDevices
      const tempContainers = []
      for (const container of job.unitLoadDevices) {
        if (!container.delete) {
          tempContainers.push(container)
        }
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (container.delete && !StrUtils.isEmpty(container.uuid)) {
          if (!job.delUnitLoadDeviceUuids) {
            job.delUnitLoadDeviceUuids = []
          }
          job.delUnitLoadDeviceUuids.push(container.uuid)
        }
      }

      job.unitLoadDevices.splice(0, job.unitLoadDevices.length, ...tempContainers)

      // 箱子 下的装箱 usage 集合到job 上
      const unitLoadDeviceUsages = []
      for (const container of job.unitLoadDevices) {
        for (const usage of container.unitLoadDeviceUsages) {
          unitLoadDeviceUsages.push(usage)
        }
      }
      job.unitLoadDeviceUsages.splice(0, job.unitLoadDeviceUsages.length, ...unitLoadDeviceUsages)
    }
  }
  /**
   * 是否有匹配的装箱信息
   */
  static isMatchSeqInfo2(c, seaEqList) {
    for (const s of seaEqList) {
      if (this.check2(c, s)) {
        return true
      }
    }
    return false
  }
  /**
   * 获取有差别的装箱信息
   */
  static getDiffSeqEqContainer2(s, job, check = false) {
    const unitLoadDevices = []
    for (const c1 of job.unitLoadDevices) {
      if (this.check2(c1, s, check)) {
        unitLoadDevices.push(c1)
      }
    }
    return unitLoadDevices
  }
  /**
     * 获取有差别的装箱信息
     */
  static getDiffSeqEqContainer(s, job, check = false) {
    const unitLoadDevices = []
    for (const c1 of job.unitLoadDevices) {
      if (this.check(c1, s, check)) {
        unitLoadDevices.push(c1)
      }
    }
    return unitLoadDevices
  }

  /**
     * @private c2:UnitLoadDevice
     */
  static checkLclSlavesUsage(job, c2) {
    if (job.masterFlag) {
      for (const usage of c2.unitLoadDeviceUsage) {
        if (this.compareLclSlavesUsage(job, usage)) {
          return true
        }
      }
    }
    return false
  }

  /**
     * @private
     */
  static compareLclSlavesUsage(job, usage) {
    const lclSlaves = job.lclSlaves
    for (const lclJob of lclSlaves) {
      if (!StrUtils.isEmpty(usage.jobUuid) && usage.jobUuid === lclJob.uuid) {
        return true
      }
    }
    return false
  }

  /**
     * 获取可以删除的装箱信息
     */
  static getAllowDeleteContainer(unitLoadDevices, check = false) {
    const result = []
    for (const c of unitLoadDevices) {
      if (check || StrUtils.isEmpty(c.containerNumber)) {
        result.push(c)
      }
    }
    return result
  }

  /**
     * 是否有匹配的装箱信息
     */
  static isMatchSeqInfo(c, job, check = false) {
    for (const s of job.airUld) {
      if (this.check(c, s, check)) {
        return true
      }
    }
    return false
  }

  /**
     * @private
     */
  static getJobContainerNumber(s, job, check = false) {
    // s:SeaEQ
    let num = 0
    const unitLoadDevices = job.unitLoadDevices
    if (unitLoadDevices != null && unitLoadDevices.length > 0) {
      for (let i = unitLoadDevices.length - 1; i >= 0; i--) {
        const c = unitLoadDevices[i]
        if (this.check(c, s, check)) {
          num += 1
        }
      }
    }
    return num
  }

  static check(c, s, check) {
    if (check) {
      if (c.containerCode === s.containerCode && c.containerType === s.containerType && c.containerNumber === s.containerNumber) {
        return true
      }
    } else {
      if (c.containerCode === s.containerCode && c.containerType === s.containerType) {
        return true
      }
    }
    return false
  }
  /**
     * 删除装箱信息验证
     */
  static checkInputContainerNo(s, job) {
    for (const c of job.unitLoadDevices) {
      if (c.containerType === s.containerType && c.containerCode === s.containerCode && (!StrUtils.isEmpty(c.containerNumber))) {
        return false
      }
    }
    return true
  }

  /**
   * 获取箱量描述
   */
  static getContainerDesc(job) {
    if (!job) return ''
    const containerMap = {}
    let containerDesc = ''
    for (const cu of job.unitLoadDeviceUsages) {
      const c = cu.unitLoadDevice
      if (c) {
        if (!containerMap.hasOwnProperty(c.containerCode)) {
          containerMap[c.containerCode] = 1
        } else {
          containerMap[c.containerCode] += 1
        }
      }
    }
    for (const key in containerMap) {
      if (StrUtils.isEmpty(containerDesc)) {
        containerDesc = (containerMap[key] + ' * ' + key)
      } else {
        containerDesc += (',' + containerMap[key] + ' * ' + key)
      }
    }
    return StrUtils.isEmpty(containerDesc) ? i18n.t('CargoMsg.Cargo_None') : containerDesc
  }

  //
  /**
   * 检查是否可以删除，录入装箱信息和装过小票的不能删除
   */
  static checkCanDelAirUld(airUld, job) {
    for (const c of job.unitLoadDevices) {
      if (airUld.containerCode === c.containerCode && airUld.containerType === c.containerType &&
        (!StrUtils.isEmpty(c.containerNumber) || (c.unitLoadDeviceUsage != null && c.unitLoadDeviceUsage.length > 0))) {
        return false
      }
    }
    return true
  }

  /**
   *  组合container和seaEq关系
   */
  static refreshContainerSeaEQ(job) {
    for (const c of job.unitLoadDevices) {
      for (const s of job.airUld) {
        if (c.eqType === s.eqType && c.eqSize === s.eqSize) {
          s.joinContainerId = uidUtil.createUID()
          c.airUlds = s
          break
        }
      }
    }
  }

  /**
   * 更新箱型箱种
   * @param job
   * @param oldEqType
   * @param oldEqSize
   * @param newEqType
   * @param newEqSize
   */
  static updateEqTypeOrEqSize(job, oldEqType, oldEqSize, newEqType, newEqSize) {
    if (!job || !job.airUld || job.airUld.length === 0) return
    if (job.lob === 'SE' || job.lob === 'SI') {
      if (job.unitLoadDevices && job.unitLoadDevices.length > 0) {
        for (const container of job.unitLoadDevices) {
          if (container.eqType === oldEqType && container.eqSize === oldEqSize) {
            container.eqType = newEqType
            container.eqSize = newEqSize
            container.isDirty = true
          }
        }
      }
      if (job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length > 0) {
        for (const usage of job.unitLoadDeviceUsages) {
          if (usage.eqType === oldEqType && usage.eqSize === oldEqSize) {
            usage.eqType = newEqType
            usage.eqSize = newEqSize
            usage.isDirty = true
          }
        }
      }
    }
  }

  /**
   * 根据SEQ 刷新装箱信息
   * 仅用于新增或复制业务
   *
   */
  static autoRefreshContainerUsages(job) {
    let serialNo = 1
    // job.unitLoadDevices = []
    // job.unitLoadDeviceUsages = []
    if (job.airUld && job.airUld.length > 0) {
      for (let i = job.airUld.length - 1; i >= 0; i--) {
        const sea = job.airUld[i]
        for (let j = sea.quantity - 1; j >= 0; j--) {
          this.createContainer(job, sea, serialNo)
          serialNo++
        }
      }
    }
  }
  static createContainer(job, sea, serialNo) {
    const container = new UnitLoadDevice().fillDefaultValue().getData()
    container.eqSize = sea.eqSize
    container.eqType = sea.eqType
    container.jobUuid = job.uuid
    container.uuid = 'addContainer_' + getUuid()
    container.isDirty = true
    const u = new UnitLoadDeviceUsage().fillDefaultValue().getData()
    u.isDirty = true
    u.unitLoadDevice = container
    u.eqSize = sea.eqSize
    u.eqType = sea.eqType
    u.jobUuid = job.uuid
    u.serialNo = serialNo
    u.unitLoadDeviceUuid = container.uuid
    u.uuid = 'addContainerUsage_' + getUuid()
    container.unitLoadDeviceUsages.push(u)
    if (!job.unitLoadDevices) {
      job.unitLoadDevices = []
    }
    job.unitLoadDevices.push(container)
    if (!job.unitLoadDeviceUsages) {
      job.unitLoadDeviceUsages = []
      job.unitLoadDeviceUsages.push(u)
    } else {
      job.unitLoadDeviceUsages.push(u)
    }
  }
}
